/*
 * @Author: 张馨元 zhangxy@iynss.com
 * @Date: 2025-02-18 16:45:58
 * @LastEditors: 张馨元 zhangxy@iynss.com
 * @LastEditTime: 2025-02-19 10:43:05
 * @FilePath: /nanhua/src/api/modules/home.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {get,post} from '../request'

const home = {
    homeBanner:()=>{
       return get('/web/carouselDiagramEntity/queryByEnable')
    },
    // 首页新闻信息列表
    newsTypeInfo:(newsType)=>{
        return get('/web/newsInfoEntity/getHeadNewsInfoList',newsType)
    },
    
    // 首页产品热销列表
    hotSellList:()=>{
        return get('/web/productMarketEntity/getHotSeasonLsit')
    },

    // 首页野生菌市场行情价格
    getPriceChainList:()=>{
        return get('/web/productMarketEntity/getPriceChainList')
    },

    // 首页获取外链信息
    getLinkEntity:()=>{
        return get('/web/linkEntity/getFront')
    },

    // 首页野生菌分布查询
    mushroomDistributedEntity:()=>{
        return get('/web/mushroomDistributedEntity/getFront')
    },

    // 获取首页文章数据
    homeArticleData:(newsType)=>{
        return get('/web/newsInfoEntity/getHeadNewsInfoList?newsType='+newsType)
    },

    // 获取首页企业信息列表
    // homeCompanyInfo:(ob)=>{
    //     return get('/web/corporateInfoEntity/getCorporateSimpleList',ob)
    // },
     homeCompanyInfo:()=>{
        return post('/web/enterpriseInfoEntity/list')
    },
    // 获取野生菌基地介绍列表
    getMushroomBaseSimpleList:(ob)=>{
        return get('/web/mushroomBaseEntity/getMushroomBaseSimpleList',ob)
    },
    // 获取野生菌基地详细信息
    getMushroomBaseDetail:(id)=>{
        return get('/web/mushroomBaseEntity/getById?id='+id)
    }
}



export default home


// WEBPACK FOOTER //
// ./src/api/modules/home.js